import { SET_SCROLL_POSITION, SET_NUM_MOUSE_OVER, START_CANVAS, LOADED_ANIMATECC_JS, SET_MOUSE_DOWN } from '../constants/ActionTypes'
import _ from 'lodash'
const initialState =
  {
    readyCanvas: false,
    loadedAnimateccJS: false,
    isMouseDown: false,
    numMouseOver: 0,
    scrollPosition: {
      inRange:true,
      isMin: false,
      isMax: false
    }
  };

export default function todos (state = initialState, action) {

  const _state = _.clone(state)

  switch (action.type) {
    case START_CANVAS:
      _state.readyCanvas = true
      return _state;

    case LOADED_ANIMATECC_JS:
      _state.loadedAnimateccJS = true
      return _state;

    case SET_MOUSE_DOWN:
      // if(_state.isMouseDown != action.isMouseDown) {
      //   console.log(action.isMouseDown);
      // }
      _state.isMouseDown = action.isMouseDown;
      return _state;

    case SET_NUM_MOUSE_OVER:
      _state.numMouseOver += action.numMouseOver;
      return _state;

    case SET_SCROLL_POSITION:
      _state.scrollPosition.inRange = action.inRange;
      _state.scrollPosition.isMin =  action.isMin;
      _state.scrollPosition.isMax =  action.isMax;
      return _state;
      

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/canvas.js
 **/